import { render, staticRenderFns } from "./text-pressure.vue?vue&type=template&id=3ab0c616"
import script from "./text-pressure.vue?vue&type=script&setup=true&lang=ts"
export * from "./text-pressure.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports